module.exports = __webpack_public_path__ + "img/21.de2166c.jpg";